import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ManageTCDS from "./pages/ManageTCDS";
import TCDSForm from "./pages/TCDSForm";
import API6DForm from "./pages/API6DForm";
import API600Form from "./pages/API600Form";
import ManageMTC from "./pages/ManageMTC";
import ValveMTCForm from "./pages/ValveMTCForm";
import ViewTCDS from "./pages/ViewTCDS";
import ViewCertificate from "./pages/ViewCertificate";
import UserManagement from "./pages/admin/UserManagement";
import ValveTypes from "./pages/admin/ValveTypes";
import ValveTypeParameters from "./pages/admin/ValveTypeParameters";
import ValveTypeStandards from "./pages/admin/ValveTypeStandards";
import ParameterValues from "./pages/admin/ParameterValues";
import Accessories from "./pages/admin/Accessories";
import AccessoryParameters from "./pages/admin/AccessoryParameters";
import AccessoriesConfiguration from "./pages/admin/AccessoriesConfiguration";
import APIConfiguration from "./pages/admin/APIConfiguration";
import AccessoryComponent from "./pages/admin/AccessoryComponent";
import AccessoryConfigurations from "./pages/admin/AccessoryConfigurations";
import AccessoryConfigurationForm from "./pages/admin/AccessoryConfigurationForm";
import TestingDetails from "./pages/admin/TestingDetails";
import HeatAnnexure from "./pages/admin/HeatAnnexure";
import StandardMaster from "./pages/admin/StandardMaster";
import OperationParameterMaster from "./pages/admin/OperationParameterMaster";
import OperationParameterValues from "./pages/admin/OperationParameterValues";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes with Layout (Sidebar) */}
        <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={["admin", "sales", "quality"]}>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* Main Pages - Accessible to all authenticated users */}
          <Route path="dashboard" element={<Dashboard />} />

          {/* Manage TCDS — Sales and Admin */}
          <Route
            path="manage-tcds"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <ManageTCDS />
              </ProtectedRoute>
            }
          />

          {/* TCDS Form Routes - Sales and Admin */}
          <Route
            path="tcds/new"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <TCDSForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="tcds/edit/:id"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <TCDSForm />
              </ProtectedRoute>
            }
          />

          {/* API 6D Form Routes - Sales and Admin */}
          <Route
            path="tcds/api-6d/new"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <API6DForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="tcds/api-6d/edit/:id"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <API6DForm />
              </ProtectedRoute>
            }
          />

          {/* API 600 Form Routes - Sales and Admin */}
          <Route
            path="tcds/api-600/new"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <API600Form />
              </ProtectedRoute>
            }
          />
          <Route
            path="tcds/api-600/edit/:id"
            element={
              <ProtectedRoute allowedRoles={["sales", "admin"]}>
                <API600Form />
              </ProtectedRoute>
            }
          />

          {/* Manage MTC — Quality and Admin */}
          <Route
            path="manage-mtc"
            element={
              <ProtectedRoute allowedRoles={["quality", "admin"]}>
                <ManageMTC />
              </ProtectedRoute>
            }
          />

          {/* Edit MTC — Quality and Admin */}
          <Route
            path="mtc/edit/:id"
            element={
              <ProtectedRoute allowedRoles={["quality", "admin"]}>
                <ValveMTCForm />
              </ProtectedRoute>
            }
          />

          {/* Search Records / View TCDS List — Sales, Quality, Admin (scope handled in component) */}
          <Route
            path="view-tcds"
            element={
              <ProtectedRoute allowedRoles={["sales", "quality", "admin"]}>
                <ViewTCDS />
              </ProtectedRoute>
            }
          />

          {/* Print / Email Certificate — Quality and Admin */}
          <Route
            path="view-certificate"
            element={
              <ProtectedRoute allowedRoles={["quality", "admin"]}>
                <ViewCertificate />
              </ProtectedRoute>
            }
          />

          {/* Admin Only Routes */}
          <Route
            path="admin/users"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <UserManagement />
              </ProtectedRoute>
            }
          />

          {/* =====================================================
              VALVE CONFIGURATION (3.A) 
              Screen 1: /admin/valve-configuration  → Valve Type List
              Screen 2: /admin/valve-configuration/:valveTypeId/parameters → Parameter List
              Screen 3: /admin/valve-configuration/:valveTypeId/parameters/:parameterId/values → Value List
              Screen 4: /admin/valve-types/:valveTypeId/standards → Standards Configuration
          ===================================================== */}
          <Route
            path="admin/valve-configuration"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <ValveTypes />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/valve-configuration/:valveTypeId/parameters"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <ValveTypeParameters />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/valve-configuration/:valveTypeId/parameters/:parameterId/values"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <ParameterValues />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/valve-types/:valveTypeId/standards"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <ValveTypeStandards />
              </ProtectedRoute>
            }
          />


          {/* ACCESSORIES CONFIGURATION — goes directly to list, no landing page */}
          <Route
            path="admin/accessories-config"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <Accessories />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/accessories-config/:id/parameters"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <AccessoryParameters />
              </ProtectedRoute>
            }
          />

          <Route
            path="admin/api-config"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <APIConfiguration />
              </ProtectedRoute>
            }
          />
          {/* =====================================================
              ACCESSORY COMPONENT MASTER
              Screen 1: /admin/accessory-component → Component Type List
              Screen 2: /admin/accessory-component/:accessoryId/configurations → Config List
              Screen 3: /admin/accessory-component/:accessoryId/configurations/new → Add Form
              Screen 3: /admin/accessory-component/:accessoryId/configurations/:configId/edit → Edit Form
          ===================================================== */}
          <Route
            path="admin/accessory-component"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <AccessoryComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/accessory-component/:accessoryId/configurations"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <AccessoryConfigurations />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/accessory-component/:accessoryId/configurations/new"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <AccessoryConfigurationForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/accessory-component/:accessoryId/configurations/:configId/edit"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <AccessoryConfigurationForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/testing-details"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <TestingDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/heat-annexure"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <HeatAnnexure />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/standard-master"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <StandardMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/operation-parameter-master"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <OperationParameterMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/operation-parameter/:operationParameterId/values"
            element={
              <ProtectedRoute allowedRoles={["admin", "sales"]}>
                <OperationParameterValues />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Legacy redirects */}
        <Route path="/admin" element={<Navigate to="/dashboard" replace />} />
        <Route path="/sales" element={<Navigate to="/dashboard" replace />} />
        <Route path="/quality" element={<Navigate to="/dashboard" replace />} />

        {/* Catch all - redirect to login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;